import FootBar from '@/page/distributor/component/basic-layout/1.0.1/component/footer/index.vue'
import Header from '@/page/supplier/component/header/1.0.1/index.vue'
export default {
    data() {
        return {
        }
    },
    components: { FootBar, Header }
}
